
import {
  Button as AIMEButton,
  Input as AIMEInput,
} from "tot-loft-component-library";

import * as PRTNR from "./prtnr";

import styled from "@emotion/styled";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import ErrorModal from "./ErrorModal";
import GenericModal from "./GenericModal";
import PaymentSuceessModal from "./PaymentSuceessModal";
import PayoutCharityModal from "./PayoutCharityModal";
import PayoutModal from "./PayoutModal";
import {
  fetchWalletBalance,
  fetchWalletHistory,
} from "./redux/slices/WalletSlice";
import { formatDate } from "./utils/func";

export default function Rewardsone() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [payoutData, setPayoutData] = useState(null);
  const member = JSON.parse(localStorage.getItem("member"));
  const [showNinoErrorModal, setShowNinoErrorModal] = useState(false);
  const [ninoErrorMessage, setNinoErrorMessage] = useState("");
  const { balance, loading, error } = useSelector((state) => state.wallet);
  const { history: walletHistory, loading: walletLoading } = useSelector(
    (state) => state.wallet
  );

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => {
    setIsModalOpen(false);
  };

  const walletTableHeaders = [
    { label: "Date", flex: 1 },
    { label: "Activity Type", flex: 1 },
    { label: "Amount (£)", flex: 1 },
  ];

  const walletTableColumns = [
    { key: "date", flex: 1 },
    { key: "type", flex: 1 },
    { key: "amount", flex: 1 },
  ];

  const formattedWalletHistory =
    walletHistory?.items?.map((item) => {
      const signedAmount =
        item.type === "credit" ? `+${item.amount}` : `-${item.amount}`;

      let activityType = "";
      if (item.on_boarding_referral) {
        activityType = "Refer a Friend Reward";
      } else if (item.referral) {
        activityType = "Fixed Referral Reward";
      } else {
        activityType = "Payout";
      }

      return {
        ...item,
        date: formatDate(item.date),
        amount: signedAmount,
        balance_before: item.balance_before,
        balance_after: item.balance_after,
        type: activityType,
      };
    }) || [];

  const handleSupportClick = () => {
    window.location.href =
      "mailto:support@Paartner.com?subject=Support%20Request";
  };

  useEffect(() => {
    dispatch(fetchWalletBalance()).unwrap();
    dispatch(fetchWalletHistory()).unwrap();
  }, [dispatch]);

  return (
    <RootWrapperRewardsone>
      <Dashboard>
        <Wrapper>
          {member?.stripe_account_id === null &&
            member?.member_type === "Individual" && (
              <AlertBanner>
                <IconWrapper>
                  <svg
                    width="30"
                    height="30"
                    viewBox="0 0 30 30"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M2.5 25H27.5V27.5H2.5V25ZM5 15H7.5V23.75H5V15ZM11.25 15H13.75V23.75H11.25V15ZM16.25 15H18.75V23.75H16.25V15ZM22.5 15H25V23.75H22.5V15ZM2.5 8.75L15 2.5L27.5 8.75V13.75H2.5V8.75ZM5 10.295V11.25H25V10.295L15 5.295L5 10.295ZM15 10C14.6685 10 14.3505 9.8683 14.1161 9.63388C13.8817 9.39946 13.75 9.08152 13.75 8.75C13.75 8.41848 13.8817 8.10054 14.1161 7.86612C14.3505 7.6317 14.6685 7.5 15 7.5C15.3315 7.5 15.6495 7.6317 15.8839 7.86612C16.1183 8.10054 16.25 8.41848 16.25 8.75C16.25 9.08152 16.1183 9.39946 15.8839 9.63388C15.6495 9.8683 15.3315 10 15 10Z"
                      fill="#5954DE"
                    />
                  </svg>
                </IconWrapper>
                <AlertText>
                  <p>Update your payment details to enable payouts.</p>
                </AlertText>
              </AlertBanner>
            )}

          <DashboardHeader>
            <HeaderContent>
              <PageTitle>My Rewards</PageTitle>
              <PageSubtitle>
                Keep referring and earning rewards. Check your stats below.
              </PageSubtitle>
            </HeaderContent>

            <BalanceCard>
              <BalanceCardInner>
                <PRTNR.StatusBadge size="60px" />
                <BalanceInfo>
                  <BalanceLabel>Balance</BalanceLabel>
                  <BalanceAmount>£{balance}</BalanceAmount>
                </BalanceInfo>
                <AIMEButton
                  size="small"
                  onClick={() => openModal()}
                  disabled={
                    balance === 0 ||
                    (member?.member_type === "Individual" &&
                      member?.stripe_account_id === null)
                  }
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    flexDirection: "row",
                    alignItems: "center",
                    flex: "none",
                    borderRadius: "999px",
                    background: "rgb(33, 37, 67)",
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "contain",
                    backgroundPosition: "center",
                    boxSizing: "border-box",
                    padding: "8px 16px",
                    width: "fit-content",
                    "@media (min-width: 768px)": {
                      width: "auto",
                    },
                    "&:disabled": {
                      background: "rgba(33, 37, 67, 0.5)",
                      color: "rgba(255, 255, 255, 0.6)",
                      cursor: "not-allowed",
                      boxShadow: "none",
                    },
                  }}
                >
                  <span
                    style={{
                      color: "white",
                      textOverflow: "ellipsis",
                      fontSize: "14px",
                      fontFamily: "Montserrat, sans-serif",
                      fontWeight: "600",
                      lineHeight: "140%",
                      textAlign: "center",
                    }}
                  >
                    {member?.member_type === "Enterprise"
                      ? "Donate to Charity"
                      : "Request Payout"}
                  </span>
                </AIMEButton>
              </BalanceCardInner>
            </BalanceCard>
          </DashboardHeader>

          {member?.member_type === "Enterprise" && (
            <InfoText>
              To request a payout of your Fixed Referral Reward balance, please
              send your invoice for the full amount to{" "}
              <CustomerSupport onClick={handleSupportClick}>
                support@Paartner.com
              </CustomerSupport>
            </InfoText>
          )}

          <PaymentSection>
            <PaymentCard>
              <PaymentHeader>
                <PaymentTitle>
                  <span>Payments History</span>
                </PaymentTitle>
                <FilterWrapper>
                  <AIMEInput type="text" placeholder="Last Month" />
                </FilterWrapper>
              </PaymentHeader>
              <TableWrapper>
                <PRTNR.TableComponent
                  tableHeaders={walletTableHeaders}
                  tableColumns={walletTableColumns}
                  tableData={formattedWalletHistory}
                  loading={walletLoading}
                />
              </TableWrapper>
            </PaymentCard>
          </PaymentSection>
        </Wrapper>
      </Dashboard>

      <GenericModal isOpen={isModalOpen} onClose={closeModal}>
        {member?.member_type === "Enterprise" ? (
          <PayoutCharityModal
            isOpen={isModalOpen}
            onClose={closeModal}
            balance={balance}
            memberType={member?.member_type}
            onSuccess={(data) => {
              setPayoutData(data);
              closeModal();
              setShowSuccessModal(true);
            }}
          />
        ) : (
          <PayoutModal
            isOpen={isModalOpen}
            onClose={closeModal}
            balance={balance}
            memberType={member?.member_type}
            onSuccess={(data) => {
              setPayoutData(data);
              closeModal();
              setShowSuccessModal(true);
            }}
            onNinoError={(msg) => {
              closeModal();
              setNinoErrorMessage(msg);
              setShowNinoErrorModal(true);
            }}
          />
        )}
      </GenericModal>

      <GenericModal
        isOpen={showSuccessModal}
        onClose={() => setShowSuccessModal(false)}
      >
        <PaymentSuceessModal
          payoutData={payoutData}
          onClose={() => setShowSuccessModal(false)}
          memberType={member?.member_type}
        />
      </GenericModal>

      <GenericModal
        isOpen={showNinoErrorModal}
        onClose={() => setShowNinoErrorModal(false)}
      >
        <ErrorModal
          title="National Insurance Number is Required"
          message={ninoErrorMessage}
          onClose={() => {
            setShowNinoErrorModal(false);
            navigate("/profileone", { state: { activeItem: "bank-details" } });
          }}
        />
      </GenericModal>
    </RootWrapperRewardsone>
  );
}


const RootWrapperRewardsone = styled.div`
   display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  z-index: 2;

`;

const Dashboard = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  width: 100%;
  background: rgb(241, 245, 249);
  padding: 0 16px;

  @media (min-width: 768px) {
    padding: 0 32px;
  }

  @media (min-width: 1024px) {
    padding: 0 60px;
  }
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding-top: 16px;
  gap: 16px;

  @media (min-width: 768px) {
    gap: 20px;
    padding-top: 24px;
  }
`;

const AlertBanner = styled.div`
  display: flex;
  padding: 16px;
  align-items: center;
  gap: 12px;
  width: 100%;
  border-radius: 12px;
  background: rgba(89, 84, 222, 0.1);

  @media (min-width: 768px) {
    padding: 16px 24px;
    gap: 16px;
    border-radius: 16px;
  }
`;

const IconWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 40px;
  min-height: 40px;
  border-radius: 999px;
  background: rgba(89, 84, 222, 0.1);

  @media (min-width: 768px) {
    min-width: 48px;
    min-height: 48px;
  }

  svg {
    width: 24px;
    height: 24px;

    @media (min-width: 768px) {
      width: 30px;
      height: 30px;
    }
  }
`;

const AlertText = styled.div`
  flex: 1;

  p {
    color: #5954de;
    font-family: Montserrat, sans-serif;
    font-size: 14px;
    font-weight: 600;
    line-height: 150%;
    margin: 0;

    @media (min-width: 768px) {
      font-size: 16px;
      line-height: 160%;
    }

    @media (min-width: 1024px) {
      font-size: 20px;
      font-weight: 700;
    }
  }
`;

const DashboardHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 16px;
  width: 100%;
  padding: 16px 0;

  @media (min-width: 768px) {
    gap: 20px;
    padding: 24px 0;
  }

  @media (min-width: 1024px) {
    flex-direction: row;
    align-items: center;
    padding: 32px 0;
    gap: 24px;
  }
`;

const HeaderContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;

  @media (min-width: 768px) {
    gap: 8px;
  }
`;

const PageTitle = styled.h1`
  color: rgb(33, 37, 67);
  font-size: 28px;
  font-family: Montserrat, sans-serif;
  font-weight: 600;
  letter-spacing: -0.5px;
  margin: 0;

  @media (min-width: 768px) {
    font-size: 36px;
    letter-spacing: -0.8px;
  }

  @media (min-width: 1024px) {
    font-size: 48px;
    letter-spacing: -1px;
  }
`;

const PageSubtitle = styled.p`
  color: rgb(33, 37, 67);
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 150%;
  margin: 0;

  @media (min-width: 768px) {
    font-size: 16px;
    line-height: 160%;
  }

  @media (min-width: 1024px) {
    font-size: 18px;
  }
`;

const BalanceCard = styled.div`
  width: 100%;

  @media (min-width: 1024px) {
    width: auto;
    min-width: 400px;
  }
`;

const BalanceCardInner = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  padding: 20px;
  border-radius: 16px;
  background: rgb(255, 255, 255);
  box-shadow: 0px 1px 2px rgba(10, 13, 20, 0.03);
  border: solid 1px rgb(225, 228, 234);

  @media (min-width: 480px) {
    flex-direction: row;
    padding: 16px 24px;
    gap: 12px;
  }

  @media (min-width: 768px) {
    gap: 16px;
  }
`;

const BalanceInfo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;

  @media (min-width: 480px) {
    align-items: flex-start;
  }
`;

const BalanceLabel = styled.span`
  color: rgb(100, 116, 139);
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;

  @media (min-width: 768px) {
    font-size: 18px;
  }
`;

const BalanceAmount = styled.span`
  color: rgb(33, 37, 67);
  font-size: 28px;
  font-family: Montserrat, sans-serif;
  font-weight: 700;

  @media (min-width: 768px) {
    font-size: 30px;
  }
`;

const InfoText = styled.p`
  width: 100%;
  color: #6162c5;
  text-align: left;
  font-family: Montserrat, sans-serif;
  font-size: 12px;
  font-weight: 500;
  line-height: 160%;
  margin: 0;

  @media (min-width: 768px) {
    font-size: 14px;
    text-align: right;
  }
`;

const CustomerSupport = styled.a`
  color: #6162c5;
  font-family: Montserrat, sans-serif;
  font-size: 12px;
  font-weight: 500;
  line-height: 160%;
  text-decoration: underline;
  cursor: pointer;

  @media (min-width: 768px) {
    font-size: 14px;
  }

  &:hover {
    color: #5954de;
  }
`;

const PaymentSection = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 16px 0 24px;

  @media (min-width: 768px) {
    padding: 24px 0;
  }
`;

const PaymentCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  padding: 16px;
  border-radius: 16px;
  background: rgb(255, 255, 255);
  box-shadow: 0px 1px 2px rgba(10, 13, 20, 0.03);
  border: solid 1px rgb(225, 228, 234);

  @media (min-width: 768px) {
    padding: 24px;
    gap: 20px;
  }
`;

const PaymentHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;

  @media (min-width: 768px) {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: 20px;
  }
`;

const PaymentTitle = styled.div`
  flex: 1;

  span {
    color: rgb(33, 37, 67);
    font-size: 18px;
    font-family: Montserrat, sans-serif;
    font-weight: 600;
    line-height: 160%;

    @media (min-width: 768px) {
      font-size: 20px;
    }
  }
`;

const FilterWrapper = styled.div`
  display: flex;
  width: 100%;

  @media (min-width: 768px) {
    width: auto;
    min-width: 200px;
  }
`;

const TableWrapper = styled.div`
  overflow-x: auto;
  width: 100%;
  -webkit-overflow-scrolling: touch;

  /* Hide scrollbar for Chrome, Safari and Opera */
  &::-webkit-scrollbar {
    height: 6px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f5f9;
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb {
    background: #cbd5e1;
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #94a3b8;
  }
`;